import React from 'react';
import PropTypes from 'prop-types';

import Modal from './index';
import DataContainer from '../data';
import Loader from '../loader';
import ErrorMessage from '../error-message';
import InfoPage from '../../areas/info/components/page';
import infoPageModalQuery from './info-page-query.graphql';

const ErrorHandler = props => <ErrorMessage {...props} />;
const LoadHandler = () => <Loader />;

const InfoPageModal = props => (
  <Modal
    isOpen={props.isOpen}
    onRequestClose={() => props.onRequestClose()}
    width={480}
  >
    <DataContainer
      variables={{ id: props.infoPage }}
      query={InfoPageModal.graphQL}
      renderLoader={LoadHandler}
      renderError={ErrorHandler}
      render={({ data }) => <InfoPage {...data.page} />}
    />
  </Modal>
);

InfoPageModal.graphQL = infoPageModalQuery;

const { func, bool, number } = PropTypes;

InfoPageModal.propTypes = {
  isOpen: bool,
  infoPage: number,
  onRequestClose: func,
};

InfoPageModal.defaultProps = {
  isOpen: false,
  infoPage: undefined,
  onRequestClose: () => {},
};

export default InfoPageModal;
